(function ($, window, document, PageLoadedQueue) {
        window.PageLoadedQueue.addFunction(function () {
            $(window).on('hashchange', function () {
                if (window.location.hash) {
                    anchorLinkScroll();
                }
            });

            $(document).ready(function () {
                anchorLinkScroll();
            });

            // bypass auto scrolling.
            if ('scrollRestoration' in history) {
                history.scrollRestoration = 'manual';
            }

            function anchorLinkScroll() {
                var hash = window.location.hash;
                if (hash) {
                    var $target = $(hash);
                    var possibleParentsClasses = ['.collapse', '.tab-pane'];
                    var possibleParentsSelector = possibleParentsClasses.join(', ');
                    var $parents = $target.parents(possibleParentsSelector);
                    var boolTest = !($parents.hasClass('active') || $parents.hasClass('show') || $parents.length === 0);
                    if (boolTest) {
                        $.each($parents, function (key, value) {
                            var $parent = $(this);

                            $parent.off('shown.bs.tab');
                            $parent.on('shown.bs.tab', function () {
                                scrollingToHash(hash);
                            });
                            $parent.off('shown.bs.collapse');
                            $parent.on('shown.bs.collapse', function () {
                                scrollingToHash(hash);
                            });
                            var id = $parent.attr('id');
                            var $button = $('[data-bs-target="#' + id + '"], [href="#' + id + '"]');
                            $button.trigger('click');
                        });

                    } else {
                        scrollingToHash(hash);
                    }
                } else {
                    scrollingToHash();
                }
            }

            function scrollingToHash(hash) {
                if (hash === undefined) {
                    window.setTimeout(function () {
                        $('html,body').animate({scrollTop: 0}, 100);
                    }, 100);
                }

                var $hash = $(hash);
                if ($hash.length < 1) {
                    return;
                }

                var offsetTop = $hash.offset().top;
                var height = $('.header-fixed').height();
                offsetTop -= height;
                window.setTimeout(function () {
                    $('html,body').animate({scrollTop: offsetTop}, 500);
                }, 100)
            }
        });
    }
)(jQuery, window, document, window.PageLoadedQueue);
